var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  isValidToken,
  logout,
  refreshAuthTokens
} from "./auth-api-client";
class ApiError extends Error {
  constructor(message, status, path, errors = []) {
    super();
    this.message = message;
    this.status = status;
    this.path = path;
    this.errors = errors;
    this.message = message;
    this.status = status;
    this.path = path;
    this.errors = errors;
  }
}
const CancelToken = axios.CancelToken;
function createRequestFunction(client) {
  return function request(config) {
    const source = CancelToken.source();
    const promise = client.request(__spreadProps(__spreadValues({}, config), {
      cancelToken: source.token
    })).then((res) => res.data).catch((err) => handleApiError(err));
    const cancel = () => source.cancel();
    return Object.assign(promise, { cancel });
  };
}
function setAuthHeaders(headers) {
  var _a;
  if (!isValidToken()) {
    logout();
  }
  const token = getAccessToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    if (((_a = window.STUDENT_ENV) == null ? void 0 : _a.env) === "local") {
      const [_, payload] = token.split(".");
      headers["x-jwt-payload"] = payload;
    }
  }
}
function bearerTokenRequestInterceptor(config) {
  return __async(this, null, function* () {
    if (["/Security/Authenticate"].includes(config.url)) {
      return config;
    }
    if (!isValidToken()) {
      const refreshToken = getRefreshToken();
      if (refreshToken) {
        yield refreshAuthTokens();
      }
    }
    setAuthHeaders(config.headers);
    if (!config.headers["Authorization"]) {
      const controller = new AbortController();
      console.log(
        "Canceling API request because no Authorization header was found."
      );
      controller.abort();
      return __spreadProps(__spreadValues({}, config), {
        signal: controller.signal
      });
    }
    return config;
  });
}
function handleApiError(error) {
  var _a, _b;
  if (axios.isAxiosError(error)) {
    let status;
    let data;
    const config = error.config;
    if (error.response) {
      ({ status, data } = error.response);
    }
    const message = typeof (data == null ? void 0 : data.message) === "string" ? data == null ? void 0 : data.message : error == null ? void 0 : error.message;
    const errors = ((_a = data == null ? void 0 : data._embedded) == null ? void 0 : _a.errors) instanceof Array ? (_b = data == null ? void 0 : data._embedded.errors) == null ? void 0 : _b.map((e) => e == null ? void 0 : e.message) : null;
    throw new ApiError(
      message,
      status,
      `${config.method} ${config.baseURL}${config.url}`,
      errors
    );
  } else if (axios.isCancel(error)) {
  } else {
    throw new ApiError(error.message);
  }
}
export {
  ApiError,
  bearerTokenRequestInterceptor,
  createRequestFunction,
  setAuthHeaders
};
